module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/gamelift-2015-10-01.paginators.json
// module id = 415
// module chunks = 1